export default __webpack_public_path__ + "static/media/thumb01_flyer@2x.e4d1598a.png";